export const environment = {
  production: true,
  firebase: {
    apiKey: 'AIzaSyAU5JdhI3Ogje76O8jqRmTRUuY3rz1YQig',
    authDomain: 'icheck-dev-d9f70.firebaseapp.com',
    databaseURL: 'https://icheck-dev-d9f70.firebaseio.com',
    projectId: 'icheck-dev-d9f70',
    storageBucket: 'icheck-dev-d9f70.appspot.com',
    messagingSenderId: '738064619121',
    appId: '1:738064619121:web:89cb54bce980de57'
  },
  oidc: {
    authority: 'https://accounts.icheck.vn',
    clientId: '8406fbfa-babd-4ba5-abd1-8209e9d10a1a',
    responseType: 'id_token token',
    scope: 'openid offline'
  },
  apiBaseUrl: 'https://business-api.dev.icheck.vn/business/api/v1',
  apiBaseLogin: 'https://business-api.dev.icheck.vn/business/api',
  apiSearch: 'https://business-api.dev.icheck.vn/business/api/v2/categories/category/search',
  apiDetail: 'https://business-api.dev.icheck.vn/business/api/v2/categories/category/detail',
  apiGetChildren : 'https://business-api.dev.icheck.vn/business/api/v2/categories/category/children',
  // https://business-api.dev.icheck.vn/business/api/v2/categories/category/search?page=1&pageSize=10&name=hoa
  apiBaseUrl2: 'https://business-api.dev.icheck.vn/business/api/v1' || '',
  apiBase2Url: 'https://api.dev.icheck.vn/api/v1',
  teko_tracking: 'bad20f92-6eba-40aa-9ed8-c687c8e14531',
  // apiBase2Url: "https://api.icheck.com.vn/api/v1",
  uploadBaseUrl: 'https://upload.icheck.vn',
  uploadBaseUrl2: 'https://apis.icheck.vn/upload/image/v1',
  uploadImageBaseUrl: 'https://upload.icheck.com.vn/upload/stream',
  url_image: 'http://ucontent.icheck.vn',
  url_chat: 'https://chatapi.dev.icheck.vn',
  url_image_old: 'https://static.icheck.com.vn',
  url_socketio: 'https://realtime-logging.dev.icheck.vn',
  goong: 'https://rsapi.goong.io',
  api_key_goong: 'oYvRYZNJhT15MrR4dI0TCP3eJ9DTu6pmUQf2kmbU',
  // api_public_user: 'https://apiv2.dev.icheck.vn/social/api/common/public-info',
  api_social: 'https://api-social.icheck.com.vn/social/api',
  domain_chat: 'https://chat.dev.icheck.vn',
  redirect_domain: 'http://bussiness-center.dev.icheck.vn/sso?source=MBTT',
  redirect_QRMKT: 'https://qrmkt.dev.icheck.vn/portal/companies',
  // googleKeyAPI: 'AIzaSyB8ZDyIw9SWrbr8Rlb-Wq-Q74I5tyfs3Po'
  googleKeyAPI: 'AIzaSyB8ZDyIw9SWrbr8Rlb-Wq-Q74I5tyfs3Po',
  scanMKT: 'https://dev.q-r.vn/'
};
// uat

// // datahub
// export const environment = {
//   production: true,
//   firebase: {
//     apiKey: "AIzaSyAU5JdhI3Ogje76O8jqRmTRUuY3rz1YQig",
//     authDomain: "icheck-dev-d9f70.firebaseapp.com",
//     databaseURL: "https://icheck-dev-d9f70.firebaseio.com",
//     projectId: "icheck-dev-d9f70",
//     storageBucket: "icheck-dev-d9f70.appspot.com",
//     messagingSenderId: "738064619121",
//     appId: "1:738064619121:web:89cb54bce980de57",
//   },
//   oidc: {
//     authority: "https://accounts.icheck.vn",
//     clientId: "8406fbfa-babd-4ba5-abd1-8209e9d10a1a",
//     responseType: "id_token token",
//     scope: "openid offline",
//   },
//   // apiBaseUrl: 'https://business-api.dev.icheck.vn/business/api/v1',
//   apiBaseUrl: "https://datahub-livetest-businessapi.icheck.vn/business/api/v1",
//   apiBase2Url: "https://api.dev.icheck.vn/api/v1",
//   // apiBase2Url: "https://api.icheck.com.vn/api/v1",
//   uploadBaseUrl: "https://upload.icheck.vn",
//   uploadBaseUrl2: "https://apis.icheck.vn/upload/image/v1",
//   uploadImageBaseUrl: "https://apis.icheck.vn/upload/image/v1/raw",
//   url_image: "http://ucontent.icheck.vn",
//   url_chat: "https://chatapi.dev.icheck.vn",
//   url_image_old: "https://static.icheck.com.vn",
//   // url_socketio: "https://realtime-logging.dev.icheck.vn",
//   url_socketio: "https://datahub-livetest-businesslogging.icheck.vn",
//   goong: "https://rsapi.goong.io",
//   api_key_goong: "vMM2QATcZwsZVUtu0UM201n4RR6qVo58w4QjXFMq",
// };


